export default __webpack_public_path__ + "static/ActionCardReminder-334090eb7a005e4aa9294c0f5845f572.png";